import Plyr from 'plyr';

//Plyr (connection npm)
$(document).ready(function() {

    const player = new Plyr('.playerBlogVideo', {
        fullscreen: { enabled: false }
    });

    player.elements.container.addEventListener('dblclick', (event) => {
        event.stopPropagation();
        event.preventDefault();
    });

    //touch devices
    let lastTap = 0;
    player.elements.container.addEventListener('touchend', (event) => {
        const currentTime = new Date().getTime();
        const tapLength = currentTime - lastTap;

        if (tapLength < 300 && tapLength > 0) {
            event.stopPropagation();
        }

        lastTap = currentTime;
    });

    $('.modalVideoBlog').on('shown.bs.modal', function () {
        player.play();
    });

    $('.modalVideoBlog').on('hidden.bs.modal', function () {
        player.pause();
        player.currentTime = 0; // Optionally rewind to the start
    });
});